// extracted by mini-css-extract-plugin
export default {"formNameBox":"index_formNameBox_keBnF","formName":"index_formName_c2Gcn","formWarning":"index_formWarning_MEHhE","formNameStart":"index_formNameStart_o73BP"};